import { render, staticRenderFns } from "./our-church.vue?vue&type=template&id=b6e0eae8&scoped=true&lang=pug&"
import script from "./our-church.vue?vue&type=script&lang=js&"
export * from "./our-church.vue?vue&type=script&lang=js&"
import style0 from "./our-church.vue?vue&type=style&index=0&id=b6e0eae8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e0eae8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VRow})
